export enum SceneMode {
  Scene2d,
  Scene3d,
}
